import { useCallback, useState } from 'react'
import { useLocalStorage } from 'react-use'

export const useClosableBanner = (storageKey: string) => {
  const [isBannerClosed, setIsBannerClosed] = useLocalStorage<boolean | undefined>(storageKey)
  const [isClosed, setIsClosed] = useState<boolean>(!!isBannerClosed)

  const close = useCallback(() => {
    setIsClosed(true)
    setIsBannerClosed(true)
  }, [setIsBannerClosed])

  return { isClosed, close }
}
